import apiClient from "QueryClient/axiosClient";

export const loginWithLinkedin = async (data) => {
  // make api call to backend using code
  return apiClient.post(`/auth/login`, data);
};
